<template>
    <div class="land-around">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.around_section_title_img + ')'"></div>
            <!-- <h2>{{salesCard.around_section_title}}</h2> -->
            <h2 v-html="salesCard.around_section_title"></h2>
        </div>
        <div class="container">
            <div class="land-around-column-container">
                <div class="col-left">
                    <div class="column-info">
                        <div class="section-title" v-if="!isMobileChecker">
                            <h2>{{salesCard.around_section_title}}</h2>
                        </div>
                        <div class="desc-html" v-html="salesCard.around_desc"></div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="col-img">
                        <img :src="salesCard.around_pic" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-around',
        components: {
        },
        data () {
            return {
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-around.scss';
    @import '@/styles/components/sales/respond/land-around-respond.scss';
</style>